import React from 'react';
import { useRouter } from 'next/router';
import { Title as TitleBase } from '../../../../../landing.common/title';
// import { MtsGiftBanner } from '../../../../../banners/mts.gift';
import analytics from '../../../../../../helpers/analytics';
import { scrollTo } from '../../../../../../helpers';
import styles from './styles.module.scss';

export const Title: React.FC = () => {
    const {
        query: { promoPopup },
    } = useRouter();

    const isOpenPopupOnMount = typeof promoPopup === 'string' && promoPopup === 'true';

    const onOpenPopup = () => {
        analytics.emit({
            event: analytics.events.mainEvent,
            eventCategory: analytics.categories.CreditCard,
            eventAction: `Попап|Акция`,
        });
    };

    const onSuccessClick = () => {
        analytics.emit({
            event: analytics.events.mainEvent,
            eventCategory: analytics.categories.CreditCard,
            eventAction: 'Переход к анкете',
            eventLabel: 'Акция',
        });
        const element = document.getElementById('main-form');
        if (element) {
            scrollTo(element);
        }
    };

    return (
        <TitleBase
            title={
                <>
                    <span className={styles.title__text}>Подбор кредитной&nbsp;карты</span>
                    <span className={styles.title__text_mobile}>Подбор кредитной карты</span>
                </>
            }
            subTitle={<>Узнайте, какой кредитный лимит готовы одобрить банки, и&nbsp;оформите карту онлайн</>}
            titleWrapperClassName={styles.titleWrapper}
            titleClassName={styles.title}
            subTitleClassName={styles.subTitle}
            heroImg={require('./assets/hero.png')}
            // banner={
            //     <MtsGiftBanner
            //         onSuccessClick={onSuccessClick}
            //         onClick={onOpenPopup}
            //         isOpenPopupOnMount={isOpenPopupOnMount}
            //     />
            // }
        />
    );
};
